
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
name: 'order',
components: {
Group,
Cell
},
data () {
return {
}
},
mounted () {
},
methods: {
}
}
